// removed by extract-text-webpack-plugin
module.exports = {"hero":"styles__hero___2zCMP","title":"styles__title___UDE9H","content":"styles__content___xUsMc","left":"styles__left___hzZVA","right":"styles__right___3qXB9","item":"styles__item___3f2ik","consultation":"styles__consultation___2OFgw","description":"styles__description___3GyZ5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Technicians/styles.scss
// module id = 436
// module chunks = 0